module.exports = __webpack_public_path__ + "static/media/scoutAdvancedSearch.f84a0f4a.png";